import uniqBy from 'lodash/uniqBy';
import { HYDRATE } from 'next-redux-wrapper';

import { SearchActions } from '~/src/features/faq/components/Search/store/constants';
import { TInitialState } from '~/src/features/faq/components/Search/store/types';
import { InferValueTypes, THydrateAction } from '~/src/store';

import * as actions from './actions';

export type TAction = ReturnType<InferValueTypes<typeof actions>> | THydrateAction;

export const initialState: TInitialState = {
    status: 'init',
    currentPage: 0,
    pageCount: 0,
};

export const reducer = (state: TInitialState = initialState, action: TAction): TInitialState => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                ...action.payload.search,
            };
        case SearchActions.setResult: {
            const { searchValue, result, currentPage, pageCount } = action.payload;

            // Если новый поисковый запрос - заменяем результаты
            if (searchValue !== state.searchValue) {
                return {
                    searched: result.length ? result : undefined,
                    searchValue,
                    currentPage,
                    pageCount,
                    status: 'loaded',
                };
            }

            // Если тот же запрос - добавляем уникальные результаты
            const mergedArticles = state.searched
                ? uniqBy([...state.searched, ...result], '_id')
                : result;

            return {
                ...state,
                searched: mergedArticles.length ? mergedArticles : undefined,
                currentPage,
                pageCount,
                status: 'loaded',
            };
        }

        case SearchActions.clear: {
            return initialState;
        }
        case SearchActions.setStatus: {
            return {
                ...state,
                status: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};

